import React, { useState, useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

export default function PreguntaSiNo({
  textoPregunta,
  defaultValue,
  numeroPregunta,
  onChangeRespuesta,
  idSI,
  idNO,
  esObligatoria
}) {
  // Convierte el defaultValue a formato interno esperado (ej: "23_Si")
  const mapDefaultValue = (valor) => {
    if (valor === `${idSI}` || valor === `${idSI}_Si`) return `${idSI}_Si`;
    if (valor === `${idNO}` || valor === `${idNO}_No`) return `${idNO}_No`;
    return '';
  };

  const [selectedValue, setSelectedValue] = useState(mapDefaultValue(defaultValue));

  // 🔁 Actualizar estado si defaultValue cambia desde el padre
  useEffect(() => {
    const mapped = mapDefaultValue(defaultValue);
    if (mapped !== selectedValue) {
      setSelectedValue(mapped);
    }
  }, [defaultValue, idSI, idNO]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (value !== selectedValue) {
      setSelectedValue(value);
    }
  };

  useEffect(() => {
    const tieneContenido = selectedValue !== '';
    const [id, respuesta] = selectedValue.split('_');
    const respuestaObj = {
      numeroPregunta,
      tieneContenido,
      contenido: [id, respuesta],
      id,
      esObligatoria
    };
    onChangeRespuesta(respuestaObj);
  }, [selectedValue]);

  return (
    <div>
      <div>{textoPregunta}</div>
      <FormControl>
        <RadioGroup row value={selectedValue} onChange={handleChange} style={{ justifyContent: 'space-between' }}>
          <FormControlLabel value={`${idSI}_Si`} control={<Radio style={{ color: '#f1a208' }} />} label="Sí" />
          <FormControlLabel value={`${idNO}_No`} control={<Radio style={{ color: '#f1a208' }} />} label="No" />
        </RadioGroup>
      </FormControl>
      <div>
        <br />
      </div>
    </div>
  );
}
